module.exports = __webpack_public_path__ + "assets/img/base-user.058ea429.png";